import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["percent", "amount"]

  connect() {
    this.select = this.element.querySelector('select[name="kind"]')
    if (!this.select) return
    this.boundUpdate = () => this.update()
    this.select.addEventListener('change', this.boundUpdate)
    this.update()
  }

  disconnect() {
    if (this.select && this.boundUpdate) {
      this.select.removeEventListener('change', this.boundUpdate)
    }
  }

  update() {
    const kind = this.select.value
    this.percentTarget.classList.toggle('d-none', kind !== 'percent')
    this.amountTarget.classList.toggle('d-none', kind !== 'amount')
  }
}
